module.exports = __webpack_public_path__ + "static/img/jigou-hangzhou-top.5cadbea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-hangzhou-top.png
// module id = Jbiu
// module chunks = 2